import { useMemo, useState } from 'react';
import { feeds } from '../../../mocks/guaData';

const filterCats = ['全部', '综艺', '直播', '人设', '网红', '翻车'];
const tagStyle = {
  爆: 'bg-primary-500 text-background-50',
  热: 'bg-accent-500 text-background-50',
  新: 'bg-secondary-600 text-background-50',
};

export default function FeedsSection() {
  const [cat, setCat] = useState('全部');
  const [openId, setOpenId] = useState<string | null>(null);

  const list = useMemo(() => (cat === '全部' ? feeds : feeds.filter((f) => f.cate === cat)), [cat]);

  return (
    <section id="feeds" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-widest text-accent-600">Fresh Gossip</p>
          <h3 className="mt-2 text-2xl font-black text-foreground-950 md:text-3xl">反差热闻速览</h3>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            跟进每一个爆点热闻的前因后果，按栏目快速筛选你关心的瓜
          </p>
        </div>

        {/* filter tabs */}
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {filterCats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => {
                setCat(c);
                setOpenId(null);
              }}
              className={`cursor-pointer rounded-full px-5 py-2 text-sm font-semibold transition ${
                cat === c ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-primary-100'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* feed list */}
        <div className="mt-8 space-y-4">
          {list.map((f) => {
            const open = openId === f.id;
            return (
              <article
                key={f.id}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <div className="flex flex-col gap-4 p-5 md:flex-row md:items-start md:justify-between md:p-6">
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded px-2 py-0.5 text-xs font-bold ${tagStyle[f.hot as keyof typeof tagStyle]}`}>
                        {f.hot}点
                      </span>
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
                        {f.cate}
                      </span>
                      <span className="text-xs text-foreground-400">
                        <i className="ri-time-line mr-1" aria-hidden="true"></i>
                        {f.time}
                      </span>
                    </div>
                    <h4 className="mt-3 text-base font-bold leading-snug text-foreground-950 md:text-lg">{f.title}</h4>
                    <p className={`mt-2 text-sm leading-relaxed text-foreground-600 ${open ? '' : 'line-clamp-2'}`}>
                      {f.intro}
                    </p>
                    <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-400">
                      <span>
                        <i className="ri-message-3-line mr-1" aria-hidden="true"></i>
                        {f.comments} 条评论
                      </span>
                      <span>
                        <i className="ri-thumb-up-line mr-1" aria-hidden="true"></i>
                        讨论中
                      </span>
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-2 md:flex-col md:items-end">
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? null : f.id)}
                      className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-primary-50 px-4 py-2 text-sm font-semibold text-primary-700 transition hover:bg-primary-100"
                    >
                      {open ? '收起' : '查看详情'}
                      <i className={`${open ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`} aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">该栏目暂无更新，换个栏目看看吧</p>
        )}

        <div className="mt-8 text-center">
          <button
            type="button"
            className="cursor-pointer inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-foreground-800 ring-1 ring-background-200 transition hover:bg-background-200"
          >
            加载更多热闻
            <i className="ri-refresh-line" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
  );
}